// Shared score-color logic used by the dashboard "featured profiles" bars and
// the insights global score bar so both follow the same thresholds.
export const getScoreTone = (score: number): string => {
  if (score >= 70) {
    return 'bg-emerald-500';
  }

  if (score >= 45) {
    return 'bg-amber-500';
  }

  return 'bg-rose-500';
};
